import ProductCard, { ProductCardProp } from "../../components/product-card";
import { createStyles, SimpleGrid, Title, useMantineTheme } from "@mantine/core"
import ImageStorageService from "../../services/ImageStorageService"
import { useEffect, useState } from "react";
import DefaultContainer from "../../components/container";
import { useParams } from "react-router-dom";

const useStyles = createStyles((theme) => ({
    content: {
        padding: 20,
        width: '100%',
    },
    card: {
        width: '100%'
    },
    grid: {
        marginTop: 30,
        width: '100%'
    },
    title: {
        paddingBottom: 5,
        color: theme.colors.hkc[0],
        borderBottom: `5px solid ${theme.colors.hkc[1]}`,

    }
}));

interface SearchPageProps {
    list?: ProductCardProp[];
    keyword?: string
}

const SearchByKey = () => {
    const [loading, setLoading] = useState(true)
    const { classes } = useStyles()
    const theme = useMantineTheme()
    const init: SearchPageProps = {}
    const { key } = useParams()
    const [props, setProps] = useState(init)

    const fetchData = async () => {
        const imageService = new ImageStorageService
        const list = await imageService.SearchProductByKeyword(`${key}`)
        const keyword = key

        const newProps : SearchPageProps = {
            list, keyword
        }
        setProps(newProps)
    }

    useEffect(() => {
        fetchData().then((res) => setLoading(false))
    }, [])

    const cards = props.list ?? []

    return <>
        <DefaultContainer style={{ alignItems: 'center' }} loading={loading}>
            <Title className={classes.title} order={2} mt={15}>{`Search Results for "${props.keyword}"`}</Title>
            <SimpleGrid className={classes.grid} cols={4} spacing={'lg'} breakpoints={[{ maxWidth: 'lg', cols: 3 }, { maxWidth: 'md', cols: 2 }, { maxWidth: 'sm', cols: 1 }]}>
                {
                    cards.filter((v, i, a) => a.map(x => x.slug).indexOf(v.slug) == i).map((x: ProductCardProp) => {
                        return <ProductCard key={x.slug} prop={x} className={classes.card} />
                    })
                }
            </SimpleGrid>
        </DefaultContainer>
    </>

}
export default SearchByKey